import React from "react";
import { Button, FormLabel, IconButton } from "@mui/material";
import { Lesson, LessonState } from "../../types/Lessons";
import MarkChatUnreadIcon from "@mui/icons-material/MarkChatUnread";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import BookmarkAddedIcon from '@mui/icons-material/BookmarkAdded';
import DoDisturbIcon from '@mui/icons-material/DoDisturb';
import AddCircleIcon from '@mui/icons-material/AddCircle';

export type ItemButtonActions = {
  onOpen?: (lessonId: string) => void;
}

export type ItemButtonProps = {
  lesson: Lesson;
  size?: "small" | "medium";
  disablePadding?: boolean;
}

export enum SolutionStateLabel {
  draft = "Unsolved",
  review = "In review",
}

export const StateButton = (props: ItemButtonProps & ItemButtonActions) => {
  const currentIcon = (size: "small" | "medium") => {
    switch (LessonState[props.lesson.state]) {
      case LessonState.review:
        return <HourglassBottomIcon color="warning" fontSize={size} />;
      case LessonState.approved:
        return <BookmarkAddedIcon color="success" fontSize={size} />;
      case LessonState.rejected:
        return <DoDisturbIcon color="error" fontSize={size} />;
      default:
        return <AddCircleIcon color="info" fontSize={size} />;
    }
  };

  return <IconButton
    size={props.size}
    onClick={() => props.onOpen && props.onOpen(props.lesson.id)}
    sx={{ fontSize: "smaller" }}
  >
    {currentIcon(props.size ?? "small")}
  </IconButton>
}

export const CommentButton = (props: ItemButtonProps & ItemButtonActions) => {
  return (
    <Button
      variant="text"
      onClick={() => props.onOpen && props.onOpen(props.lesson.id)}
      size={props.size}
      startIcon={<MarkChatUnreadIcon />}
    >
      {props.lesson.comments ?? 0} comments
    </Button>
  )
}